import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { api, useAgentApi } from '@sib/api';

export type ExternalTokenRequestDto = {
  orgId: string;
};

export type ExternalTokenResponseDto = {
  access_token?: string;
  token_type?: string;
};

export const useExternalTokenAuth = (
  aiPort?: string | null,
  options?: UseMutationOptions<
    ExternalTokenResponseDto,
    Error,
    ExternalTokenRequestDto
  >
) => {
  const agentApi = useAgentApi(aiPort);

  return useMutation({
    ...options,
    mutationFn: async (data: ExternalTokenRequestDto) => {
      const franzToken = await api.token.tokenControllerGetFranzOboToken(
        data.orgId
      );

      const response = await agentApi.instance.get<ExternalTokenResponseDto>(
        '/auth/external-token',
        {
          params: {
            org_id: data.orgId,
            // Cache-bust: request Cache-Control is unreliable for XHR GETs; a
            // stale cached response would skip Set-Cookie and leave the iframe
            // session expired.
            _: Date.now(),
          },
          headers: {
            Authorization: `Bearer ${franzToken}`,
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
          },
          withCredentials: true,
        }
      );

      return response.data;
    },
  });
};
